import { useSnackbar } from 'notistack';
import { handleSentryDataError } from 'utils/errors';
import useTranslation from './useTranslation';

export const useCopyToClipboard = (
  data: string,
  successMessage?: string,
): (() => Promise<void>) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const defaultSuccessMessage = `${t('data')} ${t('successCopyToClipboard')}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(data);
      enqueueSnackbar(successMessage ?? defaultSuccessMessage, {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(`${t('errorCopyToClipboard')}: ${err}`, {
        variant: 'error',
      });
      handleSentryDataError(err);
    }
  };

  return copyToClipboard;
};
